<template>
  <section class="ya-te-bg-gray">
    <div class="co-container-md mx-auto px-4 py-20 md:px-0">
      <h2 class="ya-te-page-title ya-te-text-primary mb-8 text-center font-extrabold sm:mb-12">
        LINEヤフーテックアカデミー<span class="hidden md:inline">の</span><br class="md:hidden">3つの特徴
      </h2>
      <div class="flex flex-col justify-center gap-8 px-4 md:flex-row md:gap-0 md:px-0">
        <div>
          <img
            class="mx-auto"
            src="~/assets/images/YaTe/YaTeCounseling/Features/feature-curriculum-2.svg"
            alt="未経験でも安心の分かりやすいカリキュラム"
            width="339"
            height="184"
            loading="lazy"
          >
        </div>
        <div>
          <img
            class="mx-auto"
            src="~/assets/images/YaTe/YaTeCounseling/Features/feature-support-2.svg"
            alt="最後まで挫折させない圧倒的な学習サポート"
            width="339"
            height="184"
            loading="lazy"
          >
        </div>
        <div>
          <img
            class="mx-auto"
            src="~/assets/images/YaTe/YaTeCounseling/Features/feature-reskill.svg"
            alt="リスキリング補助金で受講料の最大70％を補助"
            width="339"
            height="184"
            loading="lazy"
          >
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
@import url("~/assets/css/YaTe/YaTeCommon/YaTeCommon.css");
</style>
